import { render, staticRenderFns } from "./BoxSelectionDialog.vue?vue&type=template&id=b24158fe&scoped=true"
import script from "./BoxSelectionDialog.vue?vue&type=script&lang=js"
export * from "./BoxSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./BoxSelectionDialog.vue?vue&type=style&index=0&id=b24158fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24158fe",
  null
  
)

export default component.exports